/**
 * @generated SignedSource<<8f5aee62d22560f541e66a7fccf34126>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EditObjectiveArchiveMutation$variables = {
  objectiveId: string;
};
export type EditObjectiveArchiveMutation$data = {
  readonly Objective_Archive: {
    readonly ok: boolean;
  } | null;
};
export type EditObjectiveArchiveMutation = {
  response: EditObjectiveArchiveMutation$data;
  variables: EditObjectiveArchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "objectiveId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "objectiveId",
        "variableName": "objectiveId"
      }
    ],
    "concreteType": "ArchiveObjective",
    "kind": "LinkedField",
    "name": "Objective_Archive",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditObjectiveArchiveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditObjectiveArchiveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "791a1bcae10522303440cd2d865b83a2",
    "id": null,
    "metadata": {},
    "name": "EditObjectiveArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation EditObjectiveArchiveMutation(\n  $objectiveId: ID!\n) {\n  Objective_Archive(objectiveId: $objectiveId) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "4e9cf50fcab567d1194a93a95a53b00c";

export default node;
